<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center mb-2">
        <h4 class="me-3 my-0"><strong>{{ this.user_full_name }}</strong></h4>
        <Link :href="route('worktime.office.index', { year: this.selectedYear, month: this.selectedMonth })" class="btn btn-outline-primary">
          <i class="bi bi-list"></i>&nbsp;Powrót do listy
        </Link>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Miesiąc: {{ monthNames[selectedMonth -1] }}</h3>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-secondary me-2" @click="changeMonth(-1)">← Poprzedni</button>
          <button class="btn btn-sm btn-outline-secondary" @click="changeMonth(1)">Następny →</button>
        </div>
      </div>

      <div class="row align-items-center mb-3">
		<div class="col-auto d-flex">
		  <label class="me-2">Miesiąc:</label>
		  <select v-model="selectedMonth" class="form-select form-sm" @change="onMonthChange">
			<option v-for="m in 12" :key="m" :value="m">{{ monthNames[m - 1] }}</option>
		  </select>
		</div>

        <div class="col-auto mx-2 d-flex">
          <label class="me-2">Rok:</label>
          <select v-model="selectedYear" class="form-select form-sm" @change="loadSelectedWeek">
            <option v-for="year in yearRange" :key="year" :value="year">{{ year }}</option>
          </select>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <div class="alert alert-success">
            <h5>Podsumowanie godzin pracy: <strong>{{ calculateTotalWorkHours() }}</strong></h5>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <button @click="addNew" class="btn btn-primary btn-sm mt-3 mb-3">Dodaj wpis</button>
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Projekt</th>
              <th>Opis</th>
			  <th>Liczba godzin</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, index) in weekEntries" :key="entry.id || index">
              <td>{{ index + 1 }}</td>
              <td>
                <span v-if="!isEditing[entry.id]">
                  <strong>{{ entry.project_number || '—' }}</strong>
                </span>
                <input v-else v-model="entry.project_number" class="form-control form-control-sm" placeholder="Numer projektu">
              </td>
              <td>
                <span v-if="!isEditing[entry.id]">
                  <p class="mb-0">{{ entry.description || '—' }}</p>
                </span>
                <textarea v-else v-model="entry.description" class="form-control form-control-sm" placeholder="Opis"></textarea>
                <div v-if="isEditing[entry.id]">
                  <div class="checkbox-info custom-control custom-checkbox d-flex align-items-center">
                    <input type="checkbox" class="custom-control-input" v-model="entry.project_endet" :id="'checkbox-' + entry.id" :true-value="1" :false-value="0" />
                    <label class="custom-control-label ms-2" :for="'checkbox-' + entry.id">Projekt zakończony</label>
                  </div>
                </div>
                <div v-else>
                  <label class="ms-2">
                    <span v-if="entry.project_endet == true"><strong>Projekt zakończony</strong></span>
                  </label>
                </div>
              </td>
              <td>
                <span v-if="!isEditing[entry.id]">{{ formatTime(entry.hours) || '--:--' }}</span>
				<div  v-else>
					<input type="text" v-model="entry.hours" @input="formatAsTime(entry)" placeholder="00:00" maxlength="6" class="form-control form-control-sm" pattern="^\d{1,3}:\d{2}$"> 
					<select v-model="entry.month" class="form-select form-sm mt-2" @change="onEntryMonthChange(entry)">
						<option v-for="mr in 12" :key="mr" :value="mr">{{ monthNames[mr - 1] }}</option>
					</select>
				</div>
			  </td>
              <td>
                <div v-if="isEditing[entry.id]">
                  <button @click="saveEditedEntry(entry)" class="btn btn-sm btn-success me-1">Zapisz</button>
                  <button @click="cancelEdit" class="btn btn-sm btn-secondary me-1">Anuluj</button>
                </div>
                <div v-else>
                  <button @click="editEntry(entry)" class="btn btn-sm btn-primary me-1">Edytuj</button>
                  <button @click="deleteEntry(entry)" class="btn btn-sm btn-danger">Usuń</button>
                </div>
              </td>
            </tr>

            <tr v-if="addingNew">
              <td>Nowy</td>
              <td>
                <input v-model="newEntry.project_number" class="form-control form-control-sm" placeholder="Numer projektu" />
              </td>
              <td>
                <textarea v-model="newEntry.description" class="form-control form-control-sm" placeholder="Opis"></textarea>
                <div class="checkbox-info custom-control custom-checkbox d-flex align-items-center">
                  <input type="checkbox" class="custom-control-input" v-model="newEntry.project_endet" :id="'newEntryproject_endet'" />
                  <label class="custom-control-label ms-2" :for="'newEntryproject_endet'">Projekt zakończony</label>
                </div>
              </td>
              <td>
                <input type="text" v-model="newEntry.hours" @input="formatAsTime(newEntry)" placeholder="00:00" maxlength="6" class="form-control form-control-sm" pattern="^\d{1,3}:\d{2}$">
              </td>
              <td>
                <button @click="saveNewWeekEntry" class="btn btn-sm btn-success me-1">Zapisz</button>
                <button @click="cancelNewEntry" class="btn btn-sm btn-danger">Anuluj</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-12">
          <div class="row">
            <h4 class="me-3 my-0 mb-3">Pliki:</h4>
            <div class="row">
              <ul class="list-group ps-3 me-3 mt-3 mb-3">
                <li class="list-group-item d-flex align-items-center justify-content-between fw-bold bg-light" v-if="localServiceFiles.length > 0">
                  <div class="col-12 col-sm-6 col-md-5">Nazwa pliku</div>
                  <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                  <div class="col-12 col-sm-2 col-md-3 text-end">Opcje</div>
                </li>
                <li v-if="isLoadingFiles" class="list-group-item border-0">
                  <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">Ładowanie...</div>
                </li>
                <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else v-for="file in localServiceFiles">
                  <div class="col-12 col-sm-6 col-md-5 text-break">{{ file.name }}</div>
                  <div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ formatDate(file.created_at) }}</i></div>
                  <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                    <div class="d-inline-flex">
                      <a class="btn btn-sm btn-outline-info me-2" :href="route('worktime-files.download', [file.id, file.user_id])" download>
                        <i class="bi bi-download me-1"></i>Pobierz
                      </a>
                      <button class="btn btn-sm btn-outline-danger" @click="deleteFile(file)" type="button">
                        <i class="bi bi-trash me-1"></i>Usuń
                      </button>
                    </div>
                  </div>
                </li>
                <li class="list-group-item" v-if="localServiceFiles.length <= 0 && !isLoadingFiles">
                  <i>Brak plików</i>
                </li>
              </ul>
            </div>

            <form @submit.prevent="submitForm">
              <div class="row gap-3">
                <div class="col-12 col-md-6">
                  <label for="attachments">Dodaj pliki:</label>
				  <div v-if="isLoading" class="mt-3">
					<div class="progress" style="height: 8px;">
					  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: uploadProgress + '%' }"></div>
					</div>
					<small class="text-muted">{{ uploadProgress }}%</small>
				  </div>				  
                  <input type="file" id="attachments" multiple @change="handleFileUpload" class="form-control form-control-sm" ref="fileInput" />
                  <div v-if="form.attachments.length">
                    <p class="mt-2">Załączone pliki:</p>
                    <ul class="list-group">
                      <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(file, index) in form.attachments" :key="index">
                        {{ file.name }}
                        <button type="button" class="btn btn-sm btn-danger" @click="removeFile(index)">Usuń</button>
                      </li>
                    </ul>
                  </div>
                  <div v-if="form.attachments.length">
                    <template v-if="!isLoading">
                      <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">
                        {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>


<script>
import AppLayout from "@/Layouts/App.vue";
import { router } from "@inertiajs/vue3";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import { Tooltip } from 'bootstrap';
import { isDisabled } from "bootstrap/js/src/util/index.js";

export default {
  components: { AppLayout },
  props: {
    workData: {
      type: Array,
      default: () => [],
    },
	user_id: {},
 	user_full_name: {},
	week: {
      type: Number,
      default: null,
    },
    year: {
      type: Number,
      default: null,
    },
    month: {
      type: Number,
      default: null,
    },
  },
  data() {
    const now = new Date();

    return {

      selectedMonth: this.month !== null ? this.month : (now.getMonth() + 1),
      monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      selectedYear: this.year ?? now.getFullYear(),
      selectedWeek: this.week ?? this.getWeekNumber(now),
      yearRange: Array.from({ length: 10 }, (_, i) => now.getFullYear() - 5 + i),
      weekEntries: this.workData || [],
      editingId: null,
      addingNew: false,
 	  user_id: this.user_id || '',
 	  user_full_name: this.user_full_name || '',
      newEntry: { project_number: '', description: '', hours: '', project_endet: 0 },
      isInitialLoad: true,
	  isEditing: {},
	  isLoading: false,
	  isProcessing: false,
	  uploadProgress: 0,
      uploadError: null,
      uploadSuccess: false,
	  isLoadingFiles: false,
      localServiceFiles: [], 
      form: {
        attachments: [],
      }
    };
  },
  computed: {
    formattedWeekRange() {
	  const { start, end } = this.getWeekDateRangeInMonth(this.selectedYear, this.selectedMonth, this.selectedWeek);
      return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
    },
	formattedMonth2() {
	 return `${this.selectedYear}-${String(this.selectedMonth).padStart(2, '0')}`;
  }
  },
  mounted() {
    this.isInitialLoad = false;
	 this.fetchFiles(); 
	  this.user_full_name = this.user_full_name;
  },
  methods: {
  onEntryMonthChange(entry) {
  entry.week = this.getMiddleWeekOfMonthStrict(this.selectedYear, entry.month);
},

  onMonthChange() {
    this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);
    this.loadSelectedWeek(); 
  },
getMiddleWeekOfMonthStrict(year, month) {
	const middleDate = new Date(year, month - 1, 15); 
    return this.getWeekNumber(middleDate); 
},
getWeekDateRangeInMonth(year, month, weekInMonth) {
    const firstDay
	= new Date(year, month - 1, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(1 + (weekInMonth - 1) * 7);
    const endDate = new Date(startDate);
    endDate.setDate(Math.min(startDate.getDate() + 6, new Date(year, month, 0).getDate()));
    return { start: startDate, end: endDate };
},

formatAsTime(entry) {
  let raw = entry.hours.replace(/\D/g, ''); 

  if (raw.length >= 3) {
    const hours = raw.slice(0, raw.length - 2);
    const minutes = raw.slice(-2);
    entry.hours = `${hours}:${minutes}`;
  } else {
    entry.hours = raw;
  }
},
normalizeHours(hours) {
	  if (!hours) return '00:00';
	  if (!hours.includes(':')) {
	  return hours + ':00';
	}

  const parts = hours.split(':');
  let h = parts[0] || '00';
  let m = parts[1] || '00';
  if (m.length === 1) m = m + '0'; 
  return `${h}:${m.padStart(2, '0')}`;
},

  calculateTotalWorkHours() {
    let totalMinutes = 0;

    for (let entry of this.weekEntries) {
      const time = entry.hours;
      if (!time) continue;

      const [h, m] = time.split(':').map(Number);
      totalMinutes += h * 60 + m;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  },
  
    formatDate (dateString){
  if (!dateString) return ''; 
  let localDate = new Date(dateString); 
  const timezoneOffset = localDate.getTimezoneOffset();
  localDate.setMinutes(localDate.getMinutes() - timezoneOffset);
  return localDate.toISOString().split('T')[0];
},

  formatTime(time) {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;  
  },
    getWeeksInYear(year) {
      const d = new Date(year, 11, 31);
      const week = this.getWeekNumber(d);
      return week === 1 ? 52 : week;
    },
    getMonthFromWeek(year, week) {
      const date = new Date(year, 0, 1 + (week - 1) * 7);
      return date.getMonth() + 1;
    },
    getWeekNumber(date) {
      const target = new Date(date.valueOf());
      const dayNr = (date.getDay() + 6) % 7;
      target.setDate(target.getDate() - dayNr + 3);
      const firstThursday = new Date(target.getFullYear(), 0, 4);
      const diff = target - firstThursday;
      return 1 + Math.round(diff / 604800000);
    },
    getWeekDateRange(year, week) {
      const simple = new Date(year, 0, 1 + (week - 1) * 7);
      const dayOfWeek = simple.getDay();
      const ISOweekStart = new Date(simple);
      ISOweekStart.setDate(simple.getDate() - (dayOfWeek <= 0 ? 6 : dayOfWeek - 1));
      const ISOweekEnd = new Date(ISOweekStart);
      ISOweekEnd.setDate(ISOweekStart.getDate() + 4);
      return { start: ISOweekStart, end: ISOweekEnd };
    },
	changeMonth(zmiana) {
	  console.log("Wywołano changeMonth z zmiana:", zmiana);
	  console.log("Aktualny miesiąc:", this.selectedMonth);
	  console.log("Aktualny rok:", this.selectedYear);

	  let newMonth = Number(this.selectedMonth) + zmiana;
	  let newYear = Number(this.selectedYear);


	  if (newMonth < 1) {
		newMonth = 12;
		newYear--;
	  } else if (newMonth > 12) {
		newMonth = 1;
		newYear++;
	  }

	  console.log("Nowy miesiąc po zmianie:", newMonth);
	  console.log("Nowy rok po zmianie:", newYear);

	  this.selectedYear = newYear;
	  this.selectedMonth = newMonth;
	  this.selectedWeek = this.getMiddleWeekOfMonthStrict(newYear, newMonth);
	
	  console.log("Ustawiony tydzień (middle week):", this.selectedWeek);

	  this.loadSelectedWeek();
	},

deleteEntry(entry) {

  if (!entry.id) return;

  if (confirm('Czy na pewno chcesz usunąć ten wpis?')) {
    axios.delete(route('worktime.office.destroy', { id: entry.id,  user_id: this.user_id}))
      .then(() => {
        this.loadSelectedWeek(); 
        this.showToast('success', 'Usunięto', 'Wpis został usunięty.');
      })
      .catch(() => {
        this.showToast('error', 'Błąd', 'Nie udało się usunąć wpisu.');
      });
  }
},
editEntry(entry) {
  this.$set(this.isEditing, entry.id, true);
   if (!entry.month) {
    entry.month = this.getMonthFromWeek(entry.year || this.selectedYear, entry.week);
  }
},
cancelEdit() {
  this.isEditing = {}; 
  this.loadSelectedWeek(); 
},

async saveEditedEntry(entry) {

entry.hours = this.normalizeHours(entry.hours);

if (!/^\d{1,3}:\d{2}$/.test(entry.hours)) {
  this.showToast('error', 'Błąd', 'Niepoprawny format godzin (HH:MM)');
  return;
}

  const payload = {
    id: entry.id,
    project_number: entry.project_number || '',
    project_endet: entry.project_endet ? '1' : '0',
    description: entry.description || '',
    hours: entry.hours,
 week: entry.week,
  month: entry.month,
    year: this.selectedYear,
    user_id: this.user_id,
	};
  try {
     router.put(route('worktime.office.update', { id: entry.id }), payload, {
      preserveScroll: true,
      preserveState: true,
      onSuccess: async () => {
		this.isEditing[entry.id] = false;
		
        await this.loadSelectedWeek(); 
        Toast.fire({
          icon: 'success',
          title: 'Zapisano zmiany',
          html: '<strong>Zmiany zostały zapisane.</strong>',
          timer: 1500,
          timerProgressBar: true,
        });
      },
    });

  } catch (error) {
     Toast.fire({
      icon: 'error',
      title: 'Błąd zapisu',
      html: '<strong>Nie udało się zapisać zmian.</strong><br>Spróbuj ponownie później.',
    });
  }
},

loadSelectedWeek() {
 this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);
  axios.get(route('worktime.office.data'), {
    params: {
      year: this.selectedYear,
      week: this.selectedWeek,
      user_id: this.user_id,
     month:  this.selectedMonth
	  
    },
    headers: {
      'Accept': 'application/json'
    }
  })
  .then(res => {
    this.weekEntries = res.data.workData || [];
	this.fetchFiles();
  })
  .catch(() => {
    this.weekEntries = [];
  });
},

    addNew() {
      this.addingNew = true;
      this.newEntry = { project_number: '', description: '', hours: '', project_endet: false };
	  
    },
    cancelNewEntry() {
      this.addingNew = false;
    },
	      removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
fetchFiles() {
  this.isLoadingFiles = true;
  axios.get(route('worktime-files.officeFilesIndex'), {
    params: {
      year: this.selectedYear,
	  user_id: this.user_id,
      //month: this.getMonthFromWeek(this.selectedYear, this.selectedWeek)
	  month: this.selectedMonth
    }
  }).then((response) => {
    this.localServiceFiles = response.data;
  }).finally(() => {
    this.isLoadingFiles = false;
  });
},
	handleFileUpload(event) {
	  this.uploadError = null;
	  const files = Array.from(event.target.files);

	  const maxSize = 100 * 1024 * 1024; // 100 MB
	  const validFiles = [];

	  for (let file of files) {
		if (file.size > maxSize) {
		  this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
		} else if (file.size === 0) {
		  this.uploadError = `Plik "${file.name}" jest pusty.`;
		} else {
		  validFiles.push(file);
		}
	  }

	  if (validFiles.length > 0) {
		this.form.attachments.push(...validFiles);
	  }

	  this.$refs.fileInput.value = "";
	},
async submitForm() {
  this.uploadError = null;
  this.uploadProgress = 0;
  this.isLoading = true;

  if (this.form.attachments.length === 0) {
    this.uploadError = "Nie wybrano plików do wysłania.";
    this.isLoading = false;
    return;
  }

  const formData = new FormData();
  this.form.attachments.forEach(file => formData.append('attachments[]', file));
  formData.append('okres', this.formattedMonth2);
  formData.append('user_id', this.user_id);

  try {
    await axios.post(route('worktime-files.officeFilesStore'), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      }
    });

    this.form.attachments = [];
    this.$refs.fileInput.value = "";
    this.uploadProgress = 100;

    await this.fetchFiles();

  } catch (error) {
    console.error("Błąd zapisu:", error);
    this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
  } finally {
    this.isLoading = false;
    setTimeout(() => this.uploadProgress = 0, 2000);
  }
},

	deleteFile(file) {
      if (confirm('Czy na pewno chcesz usunąć plik?')) { 
	  axios.delete(route('worktime-files.destroy', file.id)).then(() => { this.fetchFiles(); }); }
	  },
	  
async saveNewWeekEntry() {
this.selectedWeek = this.getMiddleWeekOfMonthStrict(this.selectedYear, this.selectedMonth);
this.newEntry.hours = this.normalizeHours(this.newEntry.hours);
  const payload = {
  year: this.selectedYear,
		week: this.selectedWeek,
		user_id: this.user_id,
		...this.newEntry
  };
  try {
    await router.post(route('worktime.office.officeStore'), payload, {
      preserveScroll: true,
      preserveState: true,
      onSuccess: async () => {
		this.addingNew = false;
		this.newEntry = { project_number: '', description: '', hours: '', project_endet: false };
        await this.loadSelectedWeek(); 
        Toast.fire({
          icon: 'success',
          title: 'Zapisano zmiany',
          html: '<strong>Godziny pracy zostały zapisane.</strong>',
          timer: 1500,
          timerProgressBar: true,
        });
      },
    });


  } catch (error) {
     Toast.fire({
      icon: 'error',
      title: 'Błąd zapisu',
      html: '<strong>Nie udało się zapisać zmian.</strong><br>Spróbuj ponownie później.',
    });
  }
},

	showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
	
	
	
	
  },
};
</script>
<style scoped>
.today {
  background-color: #f8f9fa;
}
.weekend {
  background-color: #f0f0f0;
}
</style>